<ion-header>
  <ion-toolbar>
    <ion-title>{{ title | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size="1.5" *ngFor="let field of fields">
        <ion-label>{{ field.label | translate }}</ion-label>
        <ion-text>{{ field.value }}</ion-text>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
